<div
  class="videojs-annotation-control-bar-list d-flex flex-column"
  [ngClass]="{
    'video-container': isVideo,
    'has-drop-up-open': dropUpOpenStartTime != null,
  }">
  <!-- <div
    class="annotation-comment-modal"
    #annotationCommentModal
    *ngIf="!disablePreview"
    [ngClass]="{
      'comment-show': activeAnnotation?.id,
      'annotation-toggled': annotationActiveToggled && activeAnnotation?.id,
    }"
    [ngStyle]="{
      top: `${activeAnnotation?.id ? modalPosition?.top : 0}px`,
      left: `${activeAnnotation?.id ? modalPosition?.left : 0}px`,
      width: `${modalPosition?.width}px`,
    }">
    <div
      class="comment-preview-container"
      *ngIf="
        activeAnnotationPlugin?.id && activeAnnotationPlugin?.hasAnnotation
      ">
      <div
        #annotationConcat
        class="annotation-concat-toggled"
        [ngClass]="{
          'concat-show': activeAnnotation?.id,
          'annotation-toggled': annotationActiveToggled && activeAnnotation?.id,
          'audio-row': isAudio,
        }"
        [ngStyle]="{
          'background-color': activeAnnotation?.id ? activeAnnotation?.color : 'transparent',
          bottom: `${activeAnnotation?.id ? concatPosition?.bottom : 0}px`,
          height: `${activeAnnotation?.id ? concatPosition?.height : 0}px`,
          left: `${activeAnnotation?.id ? concatPosition?.left : 0}px`,
        }">
      </div>
    </div>
  </div> -->
  <div
    class="annotations-bar-list-container d-block hidden-row-container"
    [ngClass]="{
      'annotation-mode-active': isAnnotationActive || isPlaying,
      'audio-row': isAudio,
    }">
    <div class="d-block matrix-row hidden-row">
      <ng-container *ngFor="let item of timelineItems; trackBy: trackByTimelineItem">
        <div
          *ngIf="item.type === 'single'"
          class="annotation-rows d-block annotation-time-range-bar"
          [ngClass]="{
            'annotation-active': activeAnnotation?.id === item.annotation?.id,
            'annotation-fade':
              activeAnnotation?.id && activeAnnotation?.id !== item.annotation?.id && annotationActiveToggled,
            'annotation-toggled': annotationActiveToggled && activeAnnotation?.id === item.annotation?.id,
            'annotation-single': item.annotation?.range?.end - item.annotation?.range?.start <= 0.5,
          }"
          [ngStyle]="{
            width: `${getAnnotationWidth(item.annotation)}%`,
            left: `${getLeftPercent(item.startTime)}%`,
            'z-index': getAnnotationZIndex(item.annotation),
          }">
        </div>
        <div
          *ngIf="item.type === 'group'"
          class="annotation-rows d-block annotation-time-range-bar annotation-group-bar"
          [ngClass]="{
            'annotation-active': isGroupActive(item),
            'annotation-toggled': isGroupToggled(item),
            'annotation-single': getGroupIsSingle(item),
          }"
          [ngStyle]="{
            width: `${getGroupWidth(item)}%`,
            left: `${getLeftPercent(item.startTime)}%`,
            'z-index': getAnnotationZIndex(item.annotations[0]) || 0,
          }">
        </div>
      </ng-container>
    </div>
  </div>
  <div
    class="annotations-bar-list-container-scroller d-block"
    [ngClass]="{ 'annotation-mode-active': isAnnotationActive || isPlaying }"
    (click)="closeDropUp()">
    <div class="d-block matrix-row">
      <ng-container *ngFor="let item of timelineItems; trackBy: trackByTimelineItem">
        <div
          *ngIf="item.type === 'single'"
          class="annotation-rows d-block annotation-time-range-bar"
          [ngClass]="{
            'annotation-active': activeAnnotation?.id === item.annotation?.id,
            'annotation-fade':
              activeAnnotation?.id && activeAnnotation?.id !== item.annotation?.id && annotationActiveToggled,
            'annotation-toggled': annotationActiveToggled && activeAnnotation?.id === item.annotation?.id,
            'annotation-single': item.annotation?.range?.end - item.annotation?.range?.start <= 0.5,
          }"
          (click)="annotationBarClick(item.annotation, true); $event.stopPropagation()"
          (mouseenter)="onTimeBarMouseEnter(item.annotation, true)"
          (mouseleave)="onTimeBarMouseLeave(item.annotation, true)"
          [ngStyle]="{
            width: `${getAnnotationWidth(item.annotation)}%`,
            left: `${getLeftPercent(item.startTime)}%`,
            'z-index': getAnnotationZIndex(item.annotation),
          }">
          <mtm-user-profile-picture
            [username]="item.annotation.comments[0].meta.user_id"
            [height]="20"
            [width]="20"
            [fontSize]="'9px'"
            [style.transform]="`translateX(${getLeftPercent(item.startTime) * -1}%)`">
          </mtm-user-profile-picture>
        </div>
        <div
          *ngIf="item.type === 'group'"
          class="annotation-rows d-block annotation-time-range-bar annotation-group-bar annotation-group-bar-wrapper"
          [ngClass]="{
            'annotation-active': isGroupActive(item),
            'annotation-toggled': isGroupToggled(item),
            'annotation-single': getGroupIsSingle(item),
            'drop-up-open': isDropUpOpen(item.startTime),
          }"
          (mouseenter)="onGroupBarMouseEnter(item)"
          (mouseleave)="onGroupBarMouseLeave(item)"
          [ngStyle]="{
            width: `${getGroupWidth(item)}%`,
            left: `${getLeftPercent(item.startTime)}%`,
            'z-index': getAnnotationZIndex(item.annotations[0]) || 0,
          }">
          <div class="annotation-group-bar-inner" (click)="toggleDropUp(item.startTime); $event.stopPropagation()">
            <div class="annotation-group-count-only">
              <span class="annotation-group-count-num">{{ item.annotations.length }}</span>
            </div>
          </div>
          <div class="annotation-drop-up-list" *ngIf="isDropUpOpen(item.startTime)" (click)="$event.stopPropagation()">
            <div
              *ngFor="let ann of item.annotations"
              class="annotation-drop-up-item"
              [ngClass]="{ 'annotation-drop-up-item-active': isActiveInDropUp(ann) }"
              (click)="selectFromGroup(ann); $event.stopPropagation()">
              <mtm-user-profile-picture
                [username]="ann.comments[0].meta.user_id"
                [height]="20"
                [width]="20"
                [fontSize]="'10px'"
                class="annotation-drop-up-avatar">
              </mtm-user-profile-picture>
              <span class="annotation-drop-up-item-label">{{ getCommentPreview(ann) }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- <div *ngIf="annotationIn2DMatrixDataModel.length > 4"
		class="more-annotations d-flex align-items-center justify-content-center p-1 mt-auto">
		<span class="d-inline-block" (click)="showMoreAnnotations()">
			{{ !isShowMoreAnnotations ? 'SHOW MORE ANNOTATIONS' : 'SHOW LESS' }}
		</span>
	</div> -->
</div>
